<template>
  <div>
    <div class="terms-bg">
      <div class="privacy-content">
        <div class="ethics"  v-if="$i18n.locale==='en'">
          <h3>Code of Ethics</h3>
          <p>Beijing Bole Technology Co., Ltd. (hereinafter referred to as the "Company") has always been committed to the mission of "To deliver lucky moments and pure fun to players all over the world!". Based on this mission, the Company provides its employees with a safe and comfortable working environment, jobs that suit their abilities, and opportunities for development. At the same time, it has established policies and guidelines to prevent, detect, and avoid fraud, corruption, or any actions that violate the company's values, including but not limited to the following:</p>
          <p>1.Compliance with Laws and Regulations <br> Compliance with laws and regulations is a fundamental principle of the Company, and this principle also applies to other places of business. Employees of the Company must not violate laws, regulations, and rules established by the Company. Any violation of the law by an employee will be subject to disciplinary action from the Company regardless of the legal penalties.</p>
          <p>2.Accuracy and Integrity of Financial Information <br> The Company strictly prepares financial reports in accordance with relevant laws and accounting standards. At the same time, to ensure the integrity and accuracy of financial information, it has designed and operates a corresponding internal control system. The Company prohibits falsification and arbitrary alteration of financial data, operational data, expense reimbursements, etc.</p>
          <p>3.Protecting Company Assets <br> Company assets are essential tools for the company to corporate performance and growth. Therefore, we must protect and proper use company assets. Company assets includes but is not limited to: physical assets, financial assets, information assets, human assets, and so on. The company prohibits illegal use, misappropriation, embezzlement, intentional damage, and wasteful expenditure of company assets.</p>
          <p>4.Fairness in Business Cooperation <br> The company maintains principles of fairness when choosing partners. We must examine potential partners to ensure they follow laws and ethics before deciding to work with them. Even after a partnership has been established, we must pay continuous attention to whether our partners are conducting themselves legally and ethically. The company prohibits commercial bribery, official embezzlement, and unjust enrichment.</p>
          <p>5.Information Security Violation and Divulgence of Confidential Information <br> The company has specifically formulated policies such as the "Confidentiality Policy", "Software Security Policy", and "Information Security Policy" to protect confidential or sensitive information, and has conducted related training on information confidentiality and security policies. Company confidential or sensitive information include but are not limited to: financial information, trade secrets, internal communication records, non-published source code, etc.</p>
          <p>6."Anti-Fraud and Whistleblower Policy" <br> The company has specifically formulated the "Anti-Fraud and Whistleblower Policy", and has established an anti-fraud work department and whistleblowing channels to strengthen the management of anti-fraud work. The company reviews the content of anti-fraud policy every year, and makes revisions when necessary, to ensure that the policy can meet the requirements of current laws and regulations. At the same time, regular inspections are conducted to prevent and supervise the management of anti-fraud work.</p>
          <p>Contact information <br> The company accepts reports from all employees, business partners, and other relevant parties on any corruption, fraud, and violations that have occurred or may occur, reports will be handled in a serious manner and with the highest level of confidentiality.</p>
          <p>If you wish to provide information about illegal and non-compliant behavior involving employees, please contact the company's anti-fraud work department. Contact Information for the anti-fraud work department is as follows:</p>
          <p>Email address: ethics@bolegames.com</p>
          <p>We reiterate that this email is not for player complaints. For game-related issues, please contact game customer service, and we will respond to your questions as soon as possible.</p>
        </div>
        <div v-else class="ethics">
          <h3>道德准则</h3>
          <p>北京博乐科技有限公司（以下简称“公司”）一直以“做全球最以玩家为中心的游戏企业”为使命，基于这一使命，建立了“目标导向、解决问题；多为深入思考、严谨细致、主动自驱；专注极致、终身学习、诚信正直”的价值观。</p>
          <p>公司给员工提供了安全舒适的工作环境，提供了适合自身能力的工作以及发展机会。同时也制定了相应的制度与准则预防、发现与阻止舞弊，贪腐或任何违反公司价值观的行为，包括但不限于以下内容：</p>
          <p>1.遵守法律法规 <br> 遵守法律法规是公司的基本原则，这个原则同样适用于其他经营场所。公司员工不得违反法律法规及公司制定的规章制度。一旦发现，不管是否收到法律制裁，公司都会对相关员工进行处罚。 </p>
          <p>2.保障财务信息的准确性与完整性 <br> 公司严格按照相关法律和会计准则的要求编制财务报告。同时为确保财务信息的完整性与准确性，设计并运行了相应的内部控制体系。公司禁止对财务数据，经营数据、费用报销等弄虚作假、随意篡改。 </p>
          <p>3.保护公司资产 <br> 公司资产是公司开展业务和经营业务的必要工具。因此，我们必须保护公司所有资产。包括但不限于：物理资产、金融资产、信息资产、人力资产等等。公司禁止非法使用、挪用、侵占、故意毁坏、挥霍浪费公司资产。 </p>
          <p>4.业务合作中保持公平公正 <br> 在选择合作伙伴时公司保持公平公正的原则。不仅在建立合作关系前，必须首先审视与我们一起工作的合作伙伴是否合法合规。建立合作伙伴关系后，也要持续关注合作伙伴是否合法合规。公司禁止商业贿赂、职务侵占、不当得利等。 </p>
          <p>5.信息安全违规及泄露机密 <br> 公司专门制定了《保密制度》、《软件安全制度》、《信息安全制度》等相关规定保护公司机密或敏感信息，并举办信息保密安全制度相关培训。公司机密或敏感信息包括但不限于：财务信息、商业秘密、公司或业务内部沟通信息、未公开内部源代码等。  </p>
          <p>6.《反舞弊及举报投诉管理办法》 <br> 公司专门制定了《反舞弊及举报投诉管理办法》，成立了反舞弊负责部门与举报渠道加强反舞弊的管理工作。公司每年审阅反舞弊相关的制度内容，并在需要的时候作出修订，以确保相关制度能够符合现行法律法规要求。同时进行定期检查从而预防与监督反舞弊的管理工作。 </p>
          <p>举报方式 <br> 公司接受所有员工、业务伙伴及其他相关方对任何已经发生或可能发生的贪腐、舞弊及违规行为的举报，并在法律法规许可范围内确保举报信息的保密性。 </p>
          <p>如果您希望提供有关涉及员工舞弊行为的信息，请联系公司反舞弊负责部门，举报邮箱如下：</p>
          <p>举报邮箱：ethics@bolegames.com</p>
          <p>再次声明此邮箱非玩家投诉邮箱，游戏相关问题请与游戏客服联系，我们将尽快回复您的问题。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Echics",
  data() {
    return {

    }
  },
};
</script>

<style scoped lang="less">
.terms-bg {
  .sm-title {
    font-weight: 900;
    font-size: 18px;
  }
};
.el-loading-spinner {
  i {
    color: #14125d;
  }
  .el-loading-text {
    color: #14125d;
    margin: 3px 0;
    font-size: 14px;
  }
}
.ethics {
  background: white;
  padding: 20px 0;
  color: #000;
  border: 3px #bdbdbd solid;
  p {
    text-align: justify;
    padding: 0 20px;
    margin-bottom: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Echics.vue